import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Empty, Select } from 'antd';
import { createUseStyles } from 'react-jss'

import { CollectionServer, GET, Model, QueryDetail, QueryOrder, QueryParam, updateInArray, ObjectToQueryParam, POSTFormData, IfElse, deleteInArray } from 'fennec-ui'
import { errorCatch } from 'fennec-ui'
import "./index.css"

import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import YImage from '../../../common/YImage';
import FestivaliMeropriyatiya from '../../forms/FestivaliMeropriyatiya';
import confirmKey from '../ConfirmKeyModal';
import Icofont from 'react-icofont';
import TantsiFestivalei from '../../forms/TantsiFestivalei';

dayjs.locale('ru');

const { Option } = Select;

const useStyles = createUseStyles({
    button: {
        marginLeft: "10px"
    }
})

export default function FestivaliBlock(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const { auth, source, create, strickted, ctx, base, sourceKey } = props;
    const [loading, setLoading] = useState(false);

    const filters = () => [
        {
            label: "Дата начала",
            name: "dataNachala",
            type: "date",
            filterType: "range",
            sort: true,
            filter: true,

            sorted: "ASC",
            filtered: [dayjs().subtract(5, "days"), dayjs().add(1, "years")],
        },
        {
            label: "Уровень фестиваля",
            name: "urovenFestivalya",
            filterType: "group",
            display: (item) => {
                return item.opisanie
            },
            queryFilter: [
                QueryDetail("model"),
                QueryOrder("ID", "ASC")
            ],
            sort: true,
            filter: true,
        },
        {
            label: "Город проведения",
            name: "gorodProvedeniya",
            filterType: "group",
            display: (item) => {
                return item.name
            },
            queryFilter: [
                QueryDetail("model"),
                QueryOrder("name", "ASC")
            ],
            sort: true,
            filter: true,
        },
        {
            label: "Направления танцев",
            name: "tantsiFestivaleiFestival.tanets",
            type: "object",
            filterType: "group",
            display: (item) => {
                return item.nazvanie
            },
            sort: false,
            filter: true,
            source: "/api/query/tantsi?detail=model&s-nazvanie=ASC",
        }
    ];

    const FilterFromContextFilter = React.useCallback(() => [
        ...ObjectToQueryParam((ctx) ? ctx : {})
    ], [ctx]);


    return (
        <div style={{ padding: "5px 10px", backgroundColor: "white", borderRadius: "4px" }}>
            {(!ctx) && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Нет данных" style={{ padding: "15px 0px" }} />}
            {(ctx) &&
                <CollectionServer
                    name={"Festivali"}
                    auth={auth}
                    size="small"
                    source={source}
                    contextFilters={FilterFromContextFilter}
                    filters={filters}
                    mode={"list"}
                    render={(item, idx, { setCollection, setCollectionItem, update }) => {
                        return (<div key={idx} style={{ width: "100%" }} className="festivals">
                            <div style={{ display: "flex", gap: "10px" }}>
                                <div style={{ flex: "78px" }}>
                                    <div style={{ width: "78px", height: "78px", overflow: "hidden" }}>
                                        <YImage image={item.afisha} minimage={item.afishaMin} width={90} hidePreview={true} />
                                    </div>
                                </div>
                                <div style={{ flex: "auto", width: "100%", fontSize: "13px" }}>
                                    <div style={{ fontWeight: "300", fontSize: "12px", fontStyle: "italic" }}>
                                        <span style={{ fontWeight: "600", fontSize: "13px" }}>
                                            {item.nazvanie}
                                        </span>
                                    </div>
                                    <div style={{ fontWeight: "300", fontSize: "13px" }}>
                                        {dayjs(item.dataNachala).format("DD.MM.YYYY")} - {dayjs(item.dataOkonchaniya).format("DD.MM.YYYY")}
                                    </div>
                                    <div>Уровень: {item?.urovenFestivalya?.opisanie}</div>
                                    <div>Город проведения: {item?.gorodProvedeniya?.name}</div>
                                    {(item?.tantsiFestivaleiFestival?.length > 0) && <div>Направления танцев:
                                        {item?.tantsiFestivaleiFestival?.map((el, idx) => {
                                            return (<span key={idx}> {el?.tanets?.nazvanie}{(idx != (item.tantsiFestivaleiFestival.length - 1)) ? "," : ""}</span>)
                                        })}
                                    </div>}
                                    {/* <div style={{ fontWeight: "300" }}>
                                    {item.opisanie}
                                </div> */}
                                </div>
                                <div style={{ flex: "25px" }}>
                                    <div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "13px" }}>

                                    </div>
                                </div>
                            </div>
                        </div>)
                    }}
                    collectionActions={() => [
                        ...IfElse(
                            (create == true), [
                            {
                                isFormData: true,
                                modify: (values) => {
                                    return { ...values, dataNachala: dayjs(values.dataNachala).format("YYYY-MM-DD"), dataOkonchaniya: dayjs(values.dataOkonchaniya).format("YYYY-MM-DD"), ...((ctx) ? ctx : {}) }
                                },
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    POSTFormData(auth, `/api/festivali/new`, values,
                                        ({ data }) => {
                                            setCollection(updateInArray(collection, data));
                                            close();
                                        },
                                        (err) => errorCatch(err, unlock));
                                },
                                form: Model,
                                meta: [
                                    {
                                        label: "Опубликовано",
                                        name: "isPublic",
                                        type: "bool",
                                    },
                                    {
                                        label: "Название",
                                        name: "nazvanie",
                                        type: "string",
                                    },
                                    {
                                        label: "Уровень фестиваля",
                                        name: "urovenFestivalya",
                                        type: "object",
                                        relation: {
                                            display: (item) => {
                                                return item.opisanie
                                            },
                                            reference: { object: "UrovenFestivalya", property: "ID" },
                                            type: "many-one",
                                        },
                                        queryFilter: [
                                            QueryParam("w-eqi-UrovenFestivalyaVidOrgUroven.Organizator.Code", sourceKey),
                                            QueryDetail("model"),
                                            QueryOrder("ID", "ASC")
                                        ]
                                    },
                                    {
                                        label: "Дата начала",
                                        name: "dataNachala",
                                        type: "date",
                                    },
                                    {
                                        label: "Дата окончания",
                                        name: "dataOkonchaniya",
                                        type: "date",
                                    },
                                    {
                                        label: "Город проведения",
                                        name: "gorodProvedeniya",
                                        type: "object",
                                        relation: {
                                            display: (item) => {
                                                return item.name
                                            },
                                            reference: { object: "City", property: "ID" },
                                            type: "many-one",
                                        },
                                        queryFilter: [
                                            QueryDetail("model"),
                                            QueryOrder("name", "ASC")
                                        ]
                                    },
                                    {
                                        label: "Ссылка на фестиваль в ВК",
                                        name: "vk",
                                        type: "string",
                                    },
                                    {
                                        label: "Описание",
                                        name: "opisanie",
                                        type: "text",
                                    },
                                    {
                                        label: "Афиша",
                                        name: "file",
                                        type: "file",
                                    }
                                ],
                                options: {
                                    initialValues: {},
                                },
                                title: "Добавить фестиваль",
                                modal: {
                                    width: "600px",
                                    title: "Новый фестиваль",
                                }
                            }], []),
                    ]}
                    modelActions={(item) => [
                        ...IfElse(
                            (create == true), [
                            {
                                title: "Изменить",
                                modal: {
                                    width: "600px",
                                    title: "Изменить фестиваль",
                                },
                                object: item,
                                // options: {
                                //     initialValues: item,
                                // },
                                isFormData: true,
                                modify: (values) => {
                                    return { ...item, ...values, dataNachala: dayjs(values.dataNachala).format("YYYY-MM-DD"), dataOkonchaniya: dayjs(values.dataOkonchaniya).format("YYYY-MM-DD") }
                                },
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    // let o = { ...item, ...values }
                                    // POST(auth, `/api/festivali/update`, o,
                                    //     ({ data }) => {
                                    //         setCollection(updateInArray(collection, data));
                                    //         close();
                                    //     }, errorCatch
                                    // );
                                    POSTFormData(auth, `/api/festivali/update`, values,
                                        ({ data }) => {
                                            setCollection(updateInArray(collection, data));
                                            close();
                                        },
                                        (err) => errorCatch(err, unlock));
                                },
                                form: Model,
                                meta: [
                                    {
                                        label: "Опубликовано",
                                        name: "isPublic",
                                        type: "bool",
                                    },
                                    {
                                        label: "Название",
                                        name: "nazvanie",
                                        type: "string",
                                    },
                                    {
                                        label: "Уровень фестиваля",
                                        name: "urovenFestivalya",
                                        type: "object",
                                        relation: {
                                            display: (item) => {
                                                return item.opisanie
                                            },
                                            reference: { object: "UrovenFestivalya", property: "ID" },
                                            type: "many-one",
                                        },
                                        queryFilter: [
                                            QueryParam("w-eqi-UrovenFestivalyaVidOrgUroven.Organizator.Code", sourceKey),
                                            QueryDetail("model"),
                                            QueryOrder("ID", "ASC")
                                        ]
                                    },
                                    {
                                        label: "Дата начала",
                                        name: "dataNachala",
                                        type: "date",
                                    },
                                    {
                                        label: "Дата окончания",
                                        name: "dataOkonchaniya",
                                        type: "date",
                                    },
                                    {
                                        label: "Город проведения",
                                        name: "gorodProvedeniya",
                                        type: "object",
                                        relation: {
                                            display: (item) => {
                                                return item.name
                                            },
                                            reference: { object: "City", property: "ID" },
                                            type: "many-one",
                                        },
                                        queryFilter: [
                                            QueryDetail("model"),
                                            QueryOrder("name", "ASC")
                                        ]
                                    },
                                    {
                                        label: "Ссылка на фестиваль в ВК",
                                        name: "vk",
                                        type: "string",
                                    },
                                    {
                                        label: "Описание",
                                        name: "opisanie",
                                        type: "text",
                                    },
                                    {
                                        label: "Новая афиша",
                                        name: "file",
                                        type: "file",
                                    },
                                    {
                                        hidden: true,
                                        label: "Афиша",
                                        name: "afisha",
                                        type: "string",
                                    },
                                    {
                                        hidden: true,
                                        label: "Миниатюра для афиши",
                                        name: "afishaMin",
                                        type: "string",
                                    },
                                ],
                            }], []),
                        ...IfElse(
                            (create == true), [{
                                auth: auth,
                                title: <span style={{ color: "red" }}>Удалить</span>,
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    confirmKey({
                                        pass: '123',
                                        title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить фестиваль</span>,
                                        icon: undefined,
                                        content: <span>Вы действительно хотите удалить фестиваль?</span>,
                                        okText: 'Удалить',
                                        cancelText: 'Отмена',
                                        onOk() {
                                            return new Promise((resolve, reject) => {
                                                GET(auth, '/api/festivali/delete/' + item.ID,
                                                    ({ data }) => {
                                                        setCollection(deleteInArray(collection, item));
                                                        resolve(data);
                                                    }, (err) => errorCatch(err, reject));
                                            }).catch(() => { });
                                        },
                                        onCancel() {
                                        },
                                    })

                                }
                            }], []),
                        {
                            create: create,
                            readonly: true,
                            noAntForm: true,
                            title: "Направления танцев",
                            modal: {
                                width: "600px",
                                bodyStyle: { padding: "12px" }
                            },
                            object: item,
                            action: (values, unlock, close, { collection, setCollection }) => { },
                            form: TantsiFestivalei // /api/festivali/tantsi/{festivalID}
                        },
                        {
                            create: create,
                            readonly: true,
                            noAntForm: true,
                            title: "Мероприятия",
                            modal: {
                                width: "600px",
                                bodyStyle: { padding: "12px" }
                            },
                            object: item,
                            action: (values, unlock, close, { collection, setCollection }) => { },
                            form: FestivaliMeropriyatiya // /api/festivali/meropriyatiya/{festivalID}
                        }
                    ]}
                />}
        </div>
    );
}
